module.exports = __webpack_public_path__ + "static/media/man-thinking.4244bcd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/man-thinking.png
// module id = 2732
// module chunks = 0